// src/pages/products/Quinthex.jsx
import React from 'react';
import ProductTemplate from '../../components/products/ProductTemplate';
import quinthexHero from '../../assets/images/expertise.jpg';
import quinthexProduct from '../../assets/images/expertise.jpg';

const Quinthex = () => {
  const features = [
    { icon: '📊', title: 'Training Record Management', description: 'Centralized digital records of all training activities' },
    { icon: '🎓', title: 'Orientation Management', description: 'Streamlined onboarding and orientation programs' },
    { icon: '📅', title: 'Training Calendar Management', description: 'Schedule and track training sessions' },
    { icon: '📈', title: 'Training Matrix Management', description: 'Visualize competency and training requirements' },
    { icon: '📚', title: 'Training Material Library', description: 'Central repository for all training content' },
    { icon: '⭐', title: 'Competency Assessment', description: 'Evaluate and track employee competencies' },
    { icon: '📜', title: 'Certificate Management', description: 'Auto-generate and manage training certificates' },
    { icon: '🤖', title: 'Automated Reminders', description: 'Smart notifications for expiring certifications' },
    { icon: '📱', title: 'Mobile Learning', description: 'Access training anywhere, anytime' },
    { icon: '📊', title: 'Advanced Analytics', description: 'Real-time insights into training effectiveness' },
    { icon: '🔗', title: 'HRIS Integration', description: 'Seamless integration with HR systems' },
    { icon: '🎯', title: 'Skill Gap Analysis', description: 'Identify and address competency gaps' }
  ];

  const benefits = [
    'Centralize all training records in one secure platform',
    'Reduce administrative time by up to 70%',
    'Ensure compliance with industry regulations',
    'Improve employee competency and performance',
    'Automate certificate generation and tracking',
    'Scalable solution for organizations of all sizes'
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Mining', 'Oil & Gas',
    'Healthcare', 'Education', 'Retail', 'Logistics',
    'Hospitality', 'Professional Services'
  ];

  const specifications = [
    { label: 'Deployment', value: 'Cloud-based (SaaS)' },
    { label: 'Platform', value: 'Web, iOS, Android' },
    { label: 'Security', value: 'SOC 2 Type II, GDPR Compliant' },
    { label: 'Integration', value: 'REST API, HRIS, SSO' },
    { label: 'Support', value: '24/7 Technical Support' },
    { label: 'Updates', value: 'Automatic monthly updates' },
    { label: 'SCORM', value: 'SCORM 1.2/2004 Compliant' },
    { label: 'Languages', value: 'Multiple languages supported' }
  ];

  return (
    <ProductTemplate
      title="Quinthex"
      badge="LMS SOFTWARE"
      tagline="Cloud-Based Learning Management System"
      description="A cloud-based learning management system software that provides organizations with all the tools and resources needed to educate and train all levels within the organization. Our solutions address unique challenges faced in various industries and provide tailored solutions to eliminate these challenges."
      heroImage={quinthexHero}
      productImage={quinthexProduct}
      features={features}
      benefits={benefits}
      industries={industries}
      specifications={specifications}
      ctaText="Request Demo"
      ctaLink="/contact"
    />
  );
};

export default Quinthex;